import config from 'config';

export const GEOGRAPHICAL_MAP = {
  id: 'Geographical Map',
  name: 'Geographical Map',
};
export const ADDRESS_MARKER = {
  site: 'mapMarker',
  icon: 'addressMarker',
};

export const ICON_TEXT_TYPE = {
  number: 'number',
  fillOnly: 'fillOnly',
};

export const DrawingOptions = {
  polygon: 'POLYGON',
  marker: 'MARKER',
  rectangle: 'RECTANGLE',
  clear: 'CLEAR',
  ellipse: 'ELLIPSE',
};
export const staticMapCustomMarker = `${config.assetBucket}icons/checkpoints/icon_checkpoint01.png`;
export const defaultStaticMapMarkerProps = 'size:mid%7Ccolor:gray%7C';
export const defaultStaticMapPathProps = 'color:blue|weight:5';

export const LOCATION_MODE = {
  HIGH_DETAIL: 'HIGH_DETAIL',
  LOW_DETAIL: 'LOW_DETAIL',
  EDIT: 'EDIT_MODE',
};

export const DEFAULT_LINE = {
  path: 'M 0,-1 0,1',
  strokeOpacity: 1,
  scale: 2,
};

export const LOW_DETAIL_CONFIG = {
  strokeOpacity: 0,
  geodesic: false,
  polylineConfig: {
    symbol: {
      ...DEFAULT_LINE,
      scale: 1,
      strokeWeight: 2,
    },
    props: { offset: '0', repeat: '7px' },
  },
};

export const HIGH_DETAIL_CONFIG = {
  strokeOpacity: 1,
  strokeWeight: 4,
  zIndex: 32,
};

export const DEFAULT_FILL_OPACITY = 0.2;

export const MAP_CONFIG = {
  overlayMarker: {
    anchor: 14,
    scaledSize: 28,
    zIndex: 20,
    iconZIndex: 999999,
  },
  normalMarker: {
    anchor: 10,
    scaledSize: 20,
    zIndex: 30,
  },
};

export const EVENT_MAP_ICON_TYPE = {
  NEWS_EVENT_SINGLE_LOC: 'newsEventSingleLoc',
  NEWS_EVENT_MULTI_LOC: 'newsEventMultiLoc',
  NEWS_EVENT_MULTI_LOC_OVERLAY: 'newsEventMultiLocOverlay',

  NON_NEWS_EVENT_SINGLE_LOC: 'nonNewsEventSingleLoc',
  NON_NEWS_EVENT_MULTI_LOC: 'nonNewsEventMultiLoc',
  NON_NEWS_EVENT_MULTI_LOC_OVERLAY: 'nonNewsEventMultiLocOverlay',

  NEWS_EVENT_POLYGON: 'newsEventPolygon',
  NEWS_EVENT_POLYGON_OVERLAY: 'newsEventPolygonOverlay',

  NON_NEWS_EVENT_POLYGON: 'nonNewsEventPolygon',
  NON_NEWS_EVENT_POLYGON_OVERLAY: 'nonNewsEventPolygonOverlay',

  NON_NEWS_EVENT_SINGLE_LOC_OVERLAY: 'nonNewsEventSingleLocOverlay',
  NEWS_EVENT_SINGLE_LOC_OVERLAY: 'newsEventSingleLocOverlay',

  NEWS_EVENT_ELLIPSE: 'newsEventEllipse',
  NEWS_EVENT_ELLIPSE_OVERLAY: 'newsEventEllipseOverlay',

  NON_NEWS_EVENT_ELLIPSE: 'nonNewsEventEllipse',
  NON_NEWS_EVENT_ELLIPSE_OVERLAY: 'nonNewsEventEllipseOverlay',
};

export const DEFAULT_ZOOM_LEVEL = 11;
export const ONE_KM_DISTANCE = 0.01;

// distance in degree based on zoom level
export const DISTANCE = {
  3: 3,
  4: 1.5,
  5: 0.7,
  6: 0.4,
  7: 0.2,
  8: 0.15,
  9: 0.07,
  10: 0.03,
  11: 0.02,
  12: 0.009,
  13: 0.004,
  14: 0.002,
  15: 0.0009,
  16: 0.0006,
  17: 0.0002,
  18: 0.0001,
  19: 0.00005,
  20: 0.00003,
  21: 0.00002,
  22: 0.000009,
};

// radius in metres based on zoom level
export const RADIUS = {
  3: { x: 900000, y: 450000 },
  4: { x: 500000, y: 250000 },
  5: { x: 200000, y: 100000 },
  6: { x: 100000, y: 50000 },
  7: { x: 50000, y: 25000 },
  8: { x: 25000, y: 12500 },
  9: { x: 12000, y: 6000 },
  10: { x: 6500, y: 3250 },
  11: { x: 2500, y: 1250 },
  12: { x: 2000, y: 1000 },
  13: { x: 1000, y: 500 },
  14: { x: 800, y: 400 },
  15: { x: 400, y: 200 },
  16: { x: 200, y: 100 },
  17: { x: 100, y: 50 },
  18: { x: 50, y: 25 },
  19: { x: 25, y: 15 },
  20: { x: 12, y: 6 },
  21: { x: 6, y: 3 },
  22: { x: 3, y: 2.5 },
};
